module.exports = __webpack_public_path__ + "4ca8edfa57117e12606864b6e52f75a3.woff";